<template v-once>
  <img src="@/assets/icons/stack_adapt_icon.webp" alt="stackadapt icon">
</template>

<script>
export default {
  name: "Stackadapt",
};
</script>

<style scoped>
</style>
